import { ConvexQueryClient } from "@convex-dev/react-query"
import { QueryClient } from "@tanstack/react-query"
import { ConvexReactClient } from "convex/react"

import { clientEnv } from "./init"

// Create a singleton Convex client instance
export const convexClient = new ConvexReactClient(clientEnv.CONVEX_URL)

// Export for non-React contexts
export { convexClient as convex }

// TanStack Query integration — keeps subscriptions alive after unmount
const convexQueryClient = new ConvexQueryClient(convexClient)

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryKeyHashFn: convexQueryClient.hashFn(),
      queryFn: convexQueryClient.queryFn(),
    },
  },
})

convexQueryClient.connect(queryClient)

export class ConvexUnavailableError extends Error {
  constructor(message = "Unable to reach the server. Please check your connection and try again.") {
    super(message)
    this.name = "ConvexUnavailableError"
  }
}

export function queryWithTimeout<T>(promise: Promise<T>, timeoutMs = 10_000): Promise<T> {
  return Promise.race([
    promise,
    new Promise<never>((_, reject) => {
      setTimeout(() => reject(new ConvexUnavailableError()), timeoutMs)
    }),
  ])
}
